export const comments_5618944 = {"data":{"data":[],"links":{}}}